import React, { useState, useEffect } from 'react';
import './NewMain.css';
import { Link } from 'react-router-dom';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import logo from "../../Images/Logo/AstraClean.png"
function CustomNav() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false); // New state for sticky

    // Toggle mobile menu
    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    // Open Google Play Store
    const openPlayStore = () => {
        window.open('https://play.google.com/store/apps/details?id=com.cleanto.astraclean', '_blank');
    };

    // Handle scroll event
    const handleScroll = () => {
        const scrollPosition = window.scrollY;
        // If the user scrolls more than 100px, add sticky class
        setIsSticky(scrollPosition > 100);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <header className="CustomNav-navbar">
            {/* <div className="CustomNav-navbar-top">
                <div className="CustomNav-navbar-hours">
                    <AccessTimeIcon className="CustomNav-navbar-time" /> Open : 9am - 5pm (Sunday - Friday)
                </div>
                <div className="CustomNav-navbar-social">
                    <Link to="#" className="CustomNav-navbar-media"><FacebookIcon /></Link>
                    <Link to="https://www.instagram.com/officialcleanto?utm_source=qr&igsh=MTdrcXNhMXF3cGp3ag==" className="CustomNav-navbar-media"><InstagramIcon /></Link>
                    <Link to="#" className="CustomNav-navbar-media"><TwitterIcon /></Link>
                    <Link to="https://www.linkedin.com/company/cleanto/" className="CustomNav-navbar-media"><LinkedInIcon /></Link>
                </div>
            </div> */}

            <div className="CustomNav-navbar-main">

                <div className="CustomNav-navbar-logo">
                    <Link to="/"><img src={logo} alt="" /> </Link>
                </div>
                <div className="CustomNav-navbar-menu-icon" onClick={toggleMenu}>
                    <MenuIcon />
                </div>

                <div className="CustomNav-navbar-buttons">
                    <div className="CustomNav-navbar-contact-info">
                        {/* <div className="CustomNav-navbar-search">
                            <input type="text" placeholder="Search..." />
                            <SearchIcon className="CustomNav-navbar-search-icon" />
                        </div> */}
                        <nav className="CustomNav-navbar-links">
                            <Link to="/">HOME</Link>
                            <Link to="/about">ABOUT US</Link>
                            <Link to="/contact">CONTACT US</Link>
                        </nav>
                        <div className="CustomNav-navbar-divider"></div>
                        <div className="CustomNav-navbar-address">
                            <LocationOnIcon />
                            <span className="CustomNav-navbar-location"> Sarjapur, Bangalore</span>
                        </div>
                    </div>
                    <div className="sidebuttons">

                    </div>

                    <div className="sidebuttons">

                        <Link to="/cart" className="CustomNav-navbar-cart-btn">
                            <ShoppingCartIcon className="CustomNav-navbar-btn-icon" /> <p>CART</p>
                        </Link>
                        <button onClick={openPlayStore} className="CustomNav-navbar-login-btn">
                            <AccountCircleIcon className="CustomNav-navbar-btn-icon" /> <p className='login'>LOGIN</p>
                        </button>
                    </div>
                </div>
            </div>



            <div className={`CustomNav-navbar-slide-div ${menuOpen ? 'active' : ''}`}>
                <div className="CustomNav-navbar-back-icon" onClick={toggleMenu}>
                    <ArrowBackIcon className="CustomNav-navbar-back" />
                </div>

                <div className="CustomNav-navbar-side-buttons">
                    <button onClick={openPlayStore} className="CustomNav-navbar-login">
                        <AccountCircleIcon className="CustomNav-navbar-btn-icon" /> LOGIN
                    </button>
                    <Link to="/cart" className="CustomNav-navbar-cart">
                        <ShoppingCartIcon className="CustomNav-navbar-btn-icon" /> CART
                    </Link>
                </div>

                <nav className="CustomNav-navbar-links">
                    <Link to="/">Home</Link>
                    <Link to="/about">About Us</Link>
                    <Link to="/home-cleaning">Full home Cleaning</Link>
                    <Link to="/sofa-cleaning">Sofa Cleaning</Link>
                    <Link to="/bathroom-cleaning">Bathroom Cleaning</Link>
                    <Link to="/Kitchen-cleaning">Kitchen Cleaning</Link>
                    <Link to="/contact">Contact Us</Link>

                    {/* <div className="CustomNav-navbar-footer">
                        Developed by <span className="CustomNav-developer-name"><a href="https://www.instagram.com/developers6_squad?igsh=MW5rbXNjNThpeHFlbw==" style={{ textDecoration: 'none' }}>Developer's Squad</a></span>
                    </div> */}
                </nav>
            </div>
        </header>
    );
}

export default CustomNav;
